var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"detalhamento-cirurgia"},[_c('li',[_vm._v("\n      Sua cirurgia está\n      "),_c('span',{staticClass:"status"},[_vm._v(_vm._s(_vm.cirurgia.StatusCirurgia))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }